import { STORE_URLS, detectMobileStore, type MobileStore } from '../../components/installBanner';

/**
 * CORE-1548 — куда ведёт один QR с главной.
 *
 * QA завернул два отдельных QR (комментарий Вероники 05.10.2026): по описанию
 * задачи код должен вести не на карточку конкретного стора, а на страницу,
 * которая сама решает — iOS в App Store, Android в Google Play, остальные
 * увидят выбор. Поэтому QR несёт адрес НАШЕЙ страницы `/download`, а разводит
 * по сторам уже она.
 *
 * Правила распознавания не свои: это тот же `detectMobileStore`, что у баннера
 * CORE-1116. Второй набор регулярных выражений на user-agent разошёлся бы с
 * первым в первый же месяц.
 */

/** Путь страницы-распределителя. Он же в таблице маршрутов (`App.tsx`). */
export const DOWNLOAD_PATH = '/download';

/**
 * Боевой адрес на случай, когда своего origin нет (нативная сборка, SSR).
 * Первый из рабочих доменов — тот же, что первым стоит в префиксах ссылок.
 */
const FALLBACK_ORIGIN = 'https://agapella.io';

/**
 * Адрес для QR. Берём ТЕКУЩИЙ origin, а не зашитый домен: код, снятый с
 * дев-стенда, должен приводить телефон на дев-стенд — иначе QA проверяет не ту
 * сборку, которую открыл.
 */
export function downloadUrl(origin?: string | null): string {
  const base = (origin || '').trim().replace(/\/+$/, '');
  return (base || FALLBACK_ORIGIN) + DOWNLOAD_PATH;
}

/** Что показать открывшему `/download`. */
export type DownloadTarget =
  /** Телефон опознан — уводим прямо в его стор. */
  | { kind: 'store'; store: MobileStore; url: string }
  /** Десктоп, бот или незнакомое устройство — предлагаем выбрать самому. */
  | { kind: 'choice' };

export function resolveDownloadTarget(
  userAgent: string | null | undefined,
  maxTouchPoints = 0,
): DownloadTarget {
  const store = detectMobileStore(userAgent, maxTouchPoints);
  return store ? { kind: 'store', store, url: STORE_URLS[store] } : { kind: 'choice' };
}
